export default __webpack_public_path__ + "static/816-cbe332b4227f0b3e0b14746c863cbef4.gif";